export default "__VITE_ASSET__a419c89b__"